import { useFieldContext } from './form';
import { Label } from '../ui/Label';
import { Textarea } from '../ui/Textarea';
import { FieldInfo } from './FieldInfo';
import { useTranslation } from 'react-i18next';

interface TextAreaFieldProps {
  label: string;
  placeholder?: string;
  rows?: number;
}

export function TextAreaField({
  label,
  placeholder,
  rows = 3,
}: TextAreaFieldProps) {
  const { t } = useTranslation('common');

  const field = useFieldContext<string>();

  return (
    <div className="w-full">
      <Label htmlFor={label}>{label}</Label>
      <Textarea
        id={label}
        value={field.state.value}
        onBlur={field.handleBlur}
        onChange={(e: any) => field.handleChange(e.target.value)}
        placeholder={placeholder ?? `${t('enter')} ${label}`}
        rows={rows}
        className={field.state.meta.errors.length > 0 ? 'border-red-500' : ''}
      />

      <FieldInfo field={field} />
    </div>
  );
}
